export default __webpack_public_path__ + "static/media/double-moon-2.5064717d.jpg";